import React, {Component} from "react";
import GoogleMap from 'google-map-react';
import interact from "interactjs";

import './AppMap.css';
import myPin from "../myPin.png";
import moment from 'moment';
import logo from "../Logo_Dial_Blanc.png";


const DIAL_CROSS_GET_MESSAGES_URL = process.env.REACT_APP_DIALCROSS_SERVER_URL + '/' + process.env.REACT_APP_GET_MESSAGES_PATH;

moment.locale("fr");

class AppMap extends Component {

    constructor() {
        super();

        this.messages = [];
        this.markers = [];
        this.geoPointsList = [];
        this.state = {
            map: null,
            maps: null,
            lastMessage: null,
            isAnErrorOccurred: false
        };
    }

    componentDidMount() {
        let t = this;

        // Set listener for new messages handling
        setInterval(() => {
            fetch(DIAL_CROSS_GET_MESSAGES_URL, {
                method: 'GET',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("dialcross-token")
                }
            }).then(
                response => response.json().then(data => {
                    if (response.status === 200) {
                        this.messages = data;
                        const lastMessageOld = this.state.lastMessage;
                        if (data.length > 0) {
                            this.getLastMessage();
                        }


                        // Test if we have to update front
                        if (lastMessageOld && this.state.lastMessage && lastMessageOld.messageID === this.state.lastMessage.messageID) {
                            console.log("Aucun nouveau message à charger");
                        }
                        else {
                            console.log("Nouveau message reçu");
                            this.clearMarkers();
                            this.setState({
                                map: this.state.map,
                                maps: this.state.maps,
                                isAnErrorOccurred: false
                            });
                            this.createAndDisplayMarkers();
                        }
                    } else {
                        t.setState({
                            isAnErrorOccurred: true
                        });
                    }

                })
            ).catch(function (error) {
                console.log("An error occurred during messages get. " + error);
                t.setState({
                    isAnErrorOccurred: true
                });
            });

        }, 60 * 100);
    }

    createAndDisplayMarkers() {
        if (this.messages.length > 0) {
            this.messages.forEach((message) => {
                if (message.positionMap.lat && message.positionMap.lng) {
                    this.geoPointsList.push(message.positionMap);
                } else {
                    console.log("Position incorrecte trouvée pour le message : " + JSON.stringify(message));
                }
            });
            this.messages.forEach((message) => {
                if (message.positionMap.lat && message.positionMap.lng) {
                    this.createAndDisplayMarker(message);
                }
            });
        }
    }
    // + ' à ' + message.positionHour
    createAndDisplayMarker(message) {
        let title = 'Position du ' + message.positionDate ;
        let image =  myPin;


        let contentStringAntonin =
            '<h2 id="firstHeading" class="h2_title">' + title + '</h2>' +
            '<div class="col-12 widgetContainer">' +

            '<div class="col-4 dataWidget" style={{float: "left"}}>' +
            '<p class= "h6"> Heure </p>' +
            '<div class="dataContainer" >' +
            '<p class= "h6_bold" style={{textAlign: "center"}}>' + message.positionHour + '</p>' +
            '</div>' +
            '</div>' +

            '<div class="col-4 dataWidget" style={{float: "left"}}>' +
            '<p class = "h6"> Latitude </p>' +
            '<div class="dataContainer">' +
            '<p class= "h6_bold">' + message.position.lat + '</p>' +
            '</div>' +
            '</div>' +


            '<div class="col-4 dataWidget" style={{float: "left"}}>' +
            '<p class = "h6"> Longitude </p>' +
            '<div class="dataContainer">' +
            '<p class= "h6_bold">' + message.position.lng + '</p>' +
            '</div>' +
            '</div>' +
            
            '<div class="col-4 dataWidget" style={{float: "left"}}>' +
            '<p class= "h6 "> Batterie Restante </p>' +
            '<div class="dataContainer" >' +
            '<p class= "h6_bold" style={{textAlign: "center"}}>' + message.batteryRemaining + '%</p>' +
            '</div>' +
            '</div>' ;


        

        contentStringAntonin = contentStringAntonin.concat(
            
            '<div class="col-4 dataWidget" style={{float: "left"}}>' +
            '<p class= "h6 "> Statut Balise </p>' +
            '<div class="dataContainer" >' +
            '<p class= "h6_bold" style={{textAlign: "center"}}>' + message.beaconStatus.libelle + '</p>' +
            '</div>' +
            '</div>' +
            '</tbody>' +
            '</div>' +
            '</div>' +
            '</div>');
            if (message.isGPSPosition) {
                contentStringAntonin = contentStringAntonin.concat('<div class="col-4 dataWidget" style={{float: "left"}}>' +
                    '<p class= "h6"> Précision</p>' +
                    '<div class="dataContainer">' +
                    '<p class= "h6_bold">  moins de 100m </p>' +
                    '</div>' +
                    '</div>');
            } else {
                contentStringAntonin = contentStringAntonin.concat('<div class="col-4 dataWidget" style={{float: "left"}}>' +
                    '<p class= "h6"> Type de Position </p>' +
                    '<div class="dataContainer">' +
                    '<p class= "h6_bold">  plus de 100m </p>' +
                    '</div>' +
                    '</div>');
            }
        let marker = new this.state.maps.Marker({
            position: {lat: message.positionMap.lat, lng: message.positionMap.lng},
            map: this.state.map,
            title: title,
            icon: image
        });

        let infowindow = new this.state.maps.InfoWindow({
            content: contentStringAntonin,
            // content: contentString

        });

        let map = this.state.map;

        marker.addListener('click', function () {
            infowindow.open(map, marker);
        });

        this.markers.push(marker);

        let flightPath = new this.state.maps.Polyline({
            path: this.geoPointsList,
            geodesic: true,
            strokeColor: '#FF583D',
            strokeOpacity: 1.0,
            strokeWeight: 3
        });

        flightPath.setMap(this.state.map);

        this.zoomToObject(flightPath);

        if (this.messages.length === 1) {
            this.state.map.setCenter(message.position);
        }
    }

    zoomToObject(obj) {
        let bounds = new this.state.maps.LatLngBounds();
        let points = obj.getPath().getArray();
        for (let n = 0; n < points.length; n++) {
            bounds.extend(points[n]);
        }
        this.state.map.fitBounds(bounds);
    }

    getNonZeroRandomNumber() {
        let random = Math.floor(Math.random() * 199) - 99;
        if (random === 0) {
            return this.getNonZeroRandomNumber();
        }
        return random;
    }

    clearMarkers() {
        for (var i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }
        this.markers = [];
        this.geoPointsList = [];
    }

    getLastMessage() {
        let messageNumber = this.messages[0].messageID;
        let lastMessage = null;
        for (let i = 0; i < this.messages.length; i++) {
            if (this.messages[i] > messageNumber) {
                lastMessage = this.messages[i];
            }
        }
        this.setState({
            map: this.state.map,
            maps: this.state.maps,
            lastMessage: lastMessage
        });

        console.log(lastMessage);
    }

    // Retiré après dernier message : à {this.state.lastMessage.positionHour}


    render() {
        let lastMessage;

        if (this.state.isAnErrorOccurred) {
            lastMessage = <div className="appMap lastMessage " >Erreur lors de la récupération des messages</div>
        }
        else if (this.state.lastMessage != null) {
            lastMessage =
                    <div className="lastMessage draggable" style={{textAlign: "center"}} id="collapseExample">
                        <h1 id="firstHeading" className="h2">
                            Dernière Position du {this.state.lastMessage.positionDate}
                        </h1>
                        <div className="col-12 widgetContainer">
                            <div className="col-4 dataWidget" style={{float: "left"}}>
                                <p className="h6 "> Heure </p>

                                <div className="dataContainer">
                                    <p className="h6_bold"
                                       style={{textAlign: "center"}}> {this.state.lastMessage.positionHour} </p>
                                </div>
                            </div>
                            <div className="col-4 dataWidget" style={{float: "left"}}>
                                <p className="h6"> Latitude </p>

                                <div className="dataContainer">
                                    <p className="h6_bold"> {this.state.lastMessage.position.lat} </p>
                                </div>
                            </div>
                            <div className="col-4 dataWidget" style={{float: "left"}}>
                                <p className="h6"> Longitude </p>

                                <div className="dataContainer">
                                    <p className="h6_bold"> {this.state.lastMessage.position.lng} </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 widgetContainer">
                        <div className="col-4 dataWidget" style={{float: "left"}}>
                                <p className="h6 "> Batterie Restante </p>

                                <div className="dataContainer">
                                    <p className="h6_bold"
                                       style={{textAlign: "center"}}> {this.state.lastMessage.batteryRemaining} % </p>
                                </div>
                            </div>
                            
                            <div className="col-4 dataWidget" style={{float: "left"}}>
                                <p className="h6 "> Statut Balise </p>

                                <div className="dataContainer">
                                    <p className="h6_bold"
                                       style={{textAlign: "center"}}> {this.state.lastMessage.beaconStatus.libelle} </p>
                                </div>
                            </div>
                            
                            <div className="col-4 dataWidget" style={{float: "left",}}>
                                <p className="h6 "> Précision </p>

                                <div className="dataContainer">
                                {this.state.lastMessage.isGPSPosition && 
                                    <p className="h6_bold"
                                       style={{textAlign: "center"}}> moins de 100m </p>
                                }
                                {!this.state.lastMessage.isGPSPosition &&
                                    <p className="h6_bold"
                                       style={{textAlign: "center"}}> plus de 100m </p>
                                }
                                </div>
                            </div>
                        </div>

                        {/* <p><u>Informations de la balise</u></p>
                    <table className="table">
                        <tbody>
                        <tr>
                            <td>Numéro du message</td> 
                            <td>{this.state.lastMessage.messageID}</td>
                        </tr>
                        <tr>
                            <td>Statut de la balise</td>
                            <td>{this.state.lastMessage.beaconStatus}</td>
                        </tr>
                        <tr>
                            <td>Batterie</td>
                            <td>{this.state.lastMessage.batteryPower}</td>
                        </tr>
                        <tr>
                            <td>Longitude</td>
                            <td>{this.state.lastMessage.position.lng}</td>
                        </tr>
                        <tr>
                            <td>Latitude</td>
                            <td>{this.state.lastMessage.position.lat}</td>
                        </tr>
                        {this.state.lastMessage.isGPSPosition && <tr>
                            <td colSpan="2">Position obtenue par GPS</td>
                        </tr>}
                        {!this.state.lastMessage.isGPSPosition && <tr>
                            <td colSpan="2">Position obtenue par GSM</td>
                        </tr>}
                        {this.state.lastMessage.isMessageSendBySMS && <tr>
                            <td colSpan="2">Message envoyé par SMS</td>
                        </tr>}
                        {!this.state.lastMessage.isMessageSendBySMS && <tr>
                            <td colSpan="2">Message envoyé par GPRS</td>
                        </tr>}
                        </tbody>
                    </table> */}
                    </div>
        } else {
            lastMessage = <div className="appMap lastMessage h2" style={{paddingLeft: 20, paddingRight: 20,}}>En attente de chargement...</div>
        }

        return (

            <div className="fullHeight no-pad appMap" style={{flex:1}}>
                <img src={logo} className="img-responsive thumbnail logo" 
                alt="Dial" style={{flex: 1, position:'absolute', width: '10%'}} /> 
             {lastMessage}
                <button className="btn btn-primary positionButton h2" type="button" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                    Cacher
                </button>

                <GoogleMap center={this.props.center} zoom={this.props.zoom}
                           bootstrapURLKeys={{key: "AIzaSyBcMul7MTJUw0OACWRgNs3fr41X-iMnrXE"}}
                           onGoogleApiLoaded={({map, maps}) => {
                               this.setState({
                                   map: map,
                                   maps: maps,
                                   lastMessage: null
                               })
                           }} yesIWantToUseGoogleMapApiInternals={true}>
                </GoogleMap>
            </div>
        )
    }

    }
   
    // target elements with the "draggable" class
interact('.draggable')
.draggable({
  // enable inertial throwing
  inertia: true,
  // keep the element within the area of it's parent
  restrict: {
    restriction: "parent",
    endOnly: false,
    elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
  },
  // enable autoScroll
  autoScroll: true,

  // call this function on every dragmove event
  onmove: dragMoveListener,
  
});

function dragMoveListener (event) {
  var target = event.target,
      // keep the dragged position in the data-x/data-y attributes
      x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
      y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

  // translate the element
  target.style.webkitTransform =
  target.style.transform =
    'translate(' + x + 'px, ' + y + 'px)';

  // update the posiion attributes
  target.setAttribute('data-x', x);
  target.setAttribute('data-y', y);
}

// this is used later in the resizing and gesture demos
window.dragMoveListener = dragMoveListener;


AppMap.defaultProps = {
    center: {lat: 5, lng: 34},
    zoom: 1.5
};

export default AppMap;